import { render, staticRenderFns } from "./commissioniPolize.vue?vue&type=template&id=36b98f11&"
import script from "./commissioniPolize.vue.ts?vue&type=script&lang=ts&"
export * from "./commissioniPolize.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports